import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41f1eb61"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "info-label" }, "预付卡", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "info-label" }, "批次ID ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "info-label" }, "所属企业", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "info-label" }, "预付卡名称", -1))
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "info-label" }, "面额", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_user_input = _resolveComponent("app-user-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    title: "绑定预付卡",
    onCancel: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        key: "submit",
        type: "primary",
        loading: _ctx.loading,
        onClick: _ctx.handleOk
      }, {
        default: _withCtx(() => [
          _createTextVNode("确认绑定")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _hoisted_1,
        _createElementVNode("span", null, _toDisplayString(_ctx.confirmInfo.cardNo), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_2,
        _createElementVNode("span", null, _toDisplayString(_ctx.confirmInfo.batchId), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.confirmInfo.enterpriseName), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_ctx.confirmInfo.cardName), 1)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", null, _toDisplayString(`${_ctx.confirmInfo.nominalAmount || 0} 元`), 1)
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "分配给",
              name: "userCode",
              rules: [{ required: true, message: '请选择要分配的人员', trigger: 'change' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_app_user_input, {
                  value: _ctx.formState.userCode,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.userCode) = $event)),
                  style: {"width":"200px"},
                  "enterprise-id": _ctx.confirmInfo.enterpriseId,
                  "is-need-user-info": true,
                  onGetUserInfo: _ctx.getUserInfo
                }, null, 8, ["value", "enterprise-id", "onGetUserInfo"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}